<!-- Wraps all FOOTER components -->

<template>
  <footer>
    <nav
      class="navbar-light border-top pt-3 pb-3"
      :class="`bg-${variant}`"
    >
      <div class="content-wrapper flex-column navbar navbar-expand-lg">
        <div class="partners flex-column">
          <ul class="navbar-nav footer-base-container mr-auto ml-auto flex-column flex-md-row">
            <li class="nav-item">
              <app-link
                class="footer-link"
                target="_blank"
                to="https://www.fokus.fraunhofer.de/"
              >
                <img
                  src="@/assets/img/fokus-logo.svg"
                  alt="Fraunhofer FOKUS icon"
                >
              </app-link>
            </li>
            <li class="nav-item">
              <app-link
                class="footer-link"
                target="_blank"
                to="https://www.piveau.de/"
              >
                <img
                  src="@/assets/img/piveau-logo-black.svg"
                  alt="Piveau icon"
                >
              </app-link>
            </li>
            <li class="nav-item">
              <span style="display:block;text-align:center;font-size:80%;font-weight:bold;">Im Auftrag der</span>
              <img
                id="senias-logo"
                src="../../assets/img/B_SEN_ASGIVA_Logo_DE_H_PW_RGB.png"
                alt="Senatsverwaltung für Integration, Arbeit und Soziales"
              >
            </li>
          </ul>
        </div>
        <div class="imprint-section">
          <ul class="navbar-nav footer-base-container mr-auto ml-auto">
            <li class="nav-item">
              <app-link
                class="footer-link"
                :to="{ path: '/imprint'}"
              >
                Impressum
              </app-link>
            </li>
            <li class="nav-item">
              <app-link
                class="footer-link"
                :to="{ path: '/privacypolicy'}"
              >
                Datenschutz
              </app-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </footer>
</template>

<script>
import { glueConfig as GLUE_CONFIG } from '@/../config/user-config';
import AppLink from './AppLink';

export default {
  name: 'Bottom',
  components: {
    AppLink,
  },
  props: {
    variant: {
      type: String,
      default: 'gray'
    }
  },
  data() {
    return {
      footerLogos: GLUE_CONFIG.images.footerLogos,
    };
  }
};
</script>

<style lang="scss" scoped>

#senias-logo {
  margin: 8px 35px 8px 0;
  width: 84mm;
  height: 12mm;
}

.navbar-nav {
  a {
    display: inline-block;
    margin-right: 1.5rem;
  }
  img {
    height: 12mm;
  }
}
.partners {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-top: 0.5rem;
}

.footer-base-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.imprint-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.5rem;
}

.imprint-section .nav-item{
  margin: 0;
}

.nav-item {
  margin: auto;
}

.footer-link {
  padding: 8px;
}
</style>
